export const byVolumeParamTooltips = {
  ratePercent: 'Transactional calculation based on the specified value in percentage terms',
  rateMin: 'The minimum value to be applied after the percentage expression calculation if the specified value exceeds the resulting percentage',
  rateAbs: 'Fixed value added to the percentage or minimum value'
};
export const byTxFinTermParamTooltips = {
  rateAbs: 'Specify a numerical value for the next transactional calculation',
  minRate: 'Specify the minimum payment to be applied after the financial term calculation'
};
